export const selectExplorer = (state) => {
    return state.explorer;
}